import * as Lo from 'lodash';
import React from 'react';
import { generatePath } from 'react-router-dom';

import { HomePage } from '../pages/index';

interface RouteType {
  name: string;
  path: string;
  component: React.ComponentType<any>;
  state?: object;
}

export const routes: RouteType[] = [{ name: 'HomePage', path: '/home', component: HomePage }];

export function getRouteByName(name: string): string {
  const idx = Lo.findIndex(routes, ['name', name]);
  if (idx === -1) return '/';
  return routes[idx].path;
}

export class Paths {
  static collectionPoint = (id) => {
    return generatePath(getRouteByName('CollectionPoint'), { id: id });
  };

  static loginpostal = () => {
    return generatePath(getRouteByName('LoginPostal'));
  };

  static application = (id) => {
    return generatePath(getRouteByName('Application'), { id: id });
  };
  static newApplication = () => {
    return generatePath(getRouteByName('Application'), { id: -1 });
  };
}
